export const getWhoCanJoinRoomValue = (freeToUse?: boolean, businessOnly?: boolean) => {
  if (freeToUse && !businessOnly) {
    return 'free';
  }

  if (!freeToUse && !businessOnly) {
    return 'subscriber';
  }

  return 'business';
};

export const transformPermissionFields = (joinValue: string) => {
  if (joinValue === 'free') {
    return {
      freeToUse: true,
      businessOnly: false,
    };
  }

  if (joinValue === 'subscriber') {
    return {
      freeToUse: false,
      businessOnly: false,
    };
  }

  return {
    freeToUse: false,
    businessOnly: true,
  };
};
